var $bd4ef464092f2e3d$exports = {};
$bd4ef464092f2e3d$exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};


export {$bd4ef464092f2e3d$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
